import React from 'react';
import type { ControlProps } from 'react-select';
import { components } from 'react-select';
import styled from 'styled-components';
import type { SortOption } from '../../CollapsedSelect';
import { TEST_ID_SORT_CONTROL } from '../../constants';

const CustomControl = (props: ControlProps<SortOption>) => {
  const { children, ...other } = props;

  return (
    <components.Control {...other}>
      <ControlBody data-testid={TEST_ID_SORT_CONTROL}>{children}</ControlBody>
    </components.Control>
  );
};

const ControlBody = styled.div`
  border: none;
  background-color: #e6e9ee;
  border-radius: 12px;
  display: flex;
`;

export default CustomControl;
